import './App.css';
// import Header from'./components/header'
// import Body from './components/body.js'
// import AboutMe from './components/AboutMe.js'
// import Projects from './components/Projects.js'
// import ContactMe from './components/ContactMe.js'
// import Domain from './components/Domain.js'
import FadeIn from 'react-fade-in';
// import Skills from './components/skills.js'
import {Suspense, lazy} from 'react';

const Header = lazy (() => import("./screens/header"))
const Body = lazy (() => import("./screens/body"))
const AboutMe = lazy (() => import("./screens/AboutMe"))
const Skills = lazy(() => import("./screens/skills"))
const Domain = lazy (() => import("./screens/Domain"))
const Projects = lazy (() => import("./screens/Projects"))
const ContactMe = lazy (() => import("./screens/ContactMe"))

function App() {
  return (
    <FadeIn>
      <div className="App">
        <Suspense fallback = {
              <div><center><h1>Loading....</h1></center></div>
            }>  
          <Header />
          <section>
            <Body />
            <AboutMe />
            <Skills />
            <Domain />
            <Projects />
            <ContactMe />
          </section>
        </Suspense>
      </div>
    </FadeIn>
  );
}

export default App;
